<template>
    <cart-item-base
        :item="item"
        :readonly="readonly"
    >
        <template slot-scope="{ removeItem, updateQuantity }">
            <div class="card">
                <div class="card-body">
                    <div class="cart-item-image col-sm-3">
                        <img
                            :src="item.image"
                            class="img-fluid"
                        >
                    </div>
                    <div class="col-sm-7">
                        <div class="cart-item-name">
                            {{ item.name }}
                        </div>
                        <div class="cart-item-amount form-inline">
                            <label class="mr-2 mb-0">{{ __('Quantity') }}</label>
                            <input
                                min="1"
                                max="9999"
                                type="number"
                                class="form-control form-control-sm"
                                :value="item.quantity"
                                :disabled="readonly"
                                @change="updateQuantity"
                            >
                        </div>
                        <div class="cart-item-price">
                            <span class="label"> {{ __('Price:') }}</span>
                            <span
                                v-if="item.totalPrice.originalGross"
                                class="original-value"
                            >
                                <s>{{ item.totalPrice.originalGross | currency }}</s>
                            </span>
                            <span class="value">{{ item.totalPrice.gross | currency }}</span>
                        </div>
                    </div>
                    <div class="col text-right">
                        <button
                            v-if="!readonly"
                            class="btn btn-sm btn-danger cart-btn-remove"
                            @click="removeItem"
                        >
                            X
                        </button>
                    </div>
                </div>
                <div
                    v-if="item.discounts.length"
                    class="card-footer"
                >
                    <component
                        :is="discount.type"
                        v-for="(discount, index) in item.discounts"
                        :key="index"
                        :discount="discount"
                    />
                </div>
            </div>
        </template>
    </cart-item-base>
</template>

<script>
export default {
    name: 'CartWidgetItem',

    props: {
        item: {
            type: Object,
            required: true
        },

        readonly: {
            type: Boolean,
            default: false
        },
    }
}
</script>
